export default "/img/BJ.8a8629cf75d926e81937527a7fc0f961.png";